import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/pipeline-monitoring/status/alert-rules/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.PIPELINE_MONITORING_STATUS_ALERT_RULES });
    context.validatePermissions({ isAllowed, preload });
  },
});
